import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import React from 'react'
import { TFlourTimeFilterValues } from 'types/models/Flours'

interface ISelectDatesProps {
  selectLabel: string
  selectList: TFlourTimeFilterValues[]
  selected: TFlourTimeFilterValues
  handleSelectChange: (selectVal: TFlourTimeFilterValues) => void
}

export const SelectDates: React.FC<ISelectDatesProps> = ({
  selectLabel,
  selectList,
  selected,
  handleSelectChange,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedValue = event.target.value as TFlourTimeFilterValues
    handleSelectChange(selectedValue)
  }

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="select-label">{selectLabel}</InputLabel>
        <Select
          labelId="simple-select-label"
          id="simple-select"
          value={selected}
          label={selectLabel}
          onChange={handleChange}
          size="small"
        >
          {selectList.map((selectVal) => (
            <MenuItem key={selectVal} value={selectVal}>
              {selectVal}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
